/**
 * Judge.meのレビュー詳細ポップアップ（スマホ）で、投稿画像の本来の
 * 縦横比をカルーセルの表示領域へ反映する。
 *
 * Judge.meは詳細ポップアップを後からDOMへ追加するため、画像の読み込みと
 * DOM追加の両方を監視する。カルーセルの選択条件・レビュー内容は変更しない。
 */
(() => {
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

  const setMediaRatio = (image) => {
    if (!mobileMediaQuery.matches || !image.naturalWidth || !image.naturalHeight) return;

    const carouselWrapper = image.closest('.jm-carousel__wrapper');
    if (!carouselWrapper) return;

    carouselWrapper.style.setProperty(
      '--jm-review-media-ratio',
      `${image.naturalWidth} / ${image.naturalHeight}`
    );
  };

  const updateModalMedia = (root = document) => {
    root.querySelectorAll?.('.jdgm-modal .jm-media__image').forEach((image) => {
      if (image.complete) {
        setMediaRatio(image);
      } else {
        image.addEventListener('load', () => setMediaRatio(image), { once: true });
      }
    });
  };

  const observeModalMedia = () => {
    updateModalMedia();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) updateModalMedia(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    mobileMediaQuery.addEventListener('change', () => updateModalMedia());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModalMedia, { once: true });
  } else {
    observeModalMedia();
  }
})();
